export function isObfuscatedProp(prop) {
    return Boolean(prop && prop === '[OMITTED]');
}
export function fixObfuscatedProp(prop) {
    return isObfuscatedProp(prop) ? undefined : prop;
}
